import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import jwt from "jwt-decode";
import { AppContext } from "../context/appContext";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function PrivateRoute({ roles, component: Component, ...rest }) {
  let decodedToken;
  const { data } = useContext(AppContext);

  const isAuthenticated = () => {
    const token = localStorage.getItem("7-star-training");
    if (token) {
      decodedToken = jwt(token.replace("Bearer ", ""));
      return true;
    }
    sessionStorage.setItem("loginRedirect", window.location.href);
    return false;
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated()) return <Redirect to="/" />;
        if (!data) {
          return (
            <Backdrop style={{ zIndex: 10000 }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          );
        }

        const status = data.subscription?.status;
        console.log("Subscription status:", status);

        const isAllowed = status === "active" || status === "trialing";

        if (!isAllowed) {
          return <Redirect to="/pricing" />;
        }

        if (!roles.includes(decodedToken.role)) {
          return <Redirect to="/" />;
        }

        return <Component {...props} />;
      }}
    />
  );
}

export default PrivateRoute;
